export default function validation(response, messages) {
  if (!response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('ONLY_ONE_LESSOR_TYPE') === 0) {
      messages.push({
        message: 'editionFournisseur.errors.pasMultiBailleur',
      });
    }
    if (message.indexOf('TIER_ALREADY_USE_IN_AN_ELEMENT') === 0) {
      messages.push({
        message: 'editionFournisseur.errors.utiliseDansAffixe',
      });
    }
  });
}
